import React, { useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import { motion } from "framer-motion";
import { FormattedMessage } from "react-intl";
import PricingModal from "../PricingModal";

const BrochureSection = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Box
        component="section"
        sx={{
          py: { xs: "32px", md: "48px" },
          px: { xs: "16px", sm: "24px", lg: "32px" },
          bgcolor: "hsl(0, 0%, 100%)",
        }}
      >
        <Box sx={{ maxWidth: "896px", mx: "auto", textAlign: "center" }}>
          <Box
            component={motion.h2}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            sx={{
              fontSize: { xs: "1.5rem", md: "1.875rem" },
              fontFamily: "Segoe UI Bold, system-ui, sans-serif",
              color: "hsl(220, 25%, 12%)",
              letterSpacing: "-0.025em",
              mb: "32px",
              mt: 0,
            }}
          >
            <FormattedMessage
              id="landing_recruiter.prices.download_text"
              values={{ b: (chunks) => <>{chunks}</> }}
            />
          </Box>
          <Box
            component={motion.div}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <Button
              onClick={() => setShowModal(true)}
              sx={{
                bgcolor: "transparent",
                color: "hsl(220, 25%, 12%)",
                border: "1px solid hsl(220, 13%, 91%)",
                fontFamily: "Segoe UI Semibold, system-ui, sans-serif",
                fontSize: "0.875rem",
                letterSpacing: "0.025em",
                px: "32px",
                height: "44px",
                borderRadius: "9999px",
                textTransform: "none",
                textDecoration: "none",
                "&:hover": {
                  bgcolor: "hsla(220, 13%, 91%, 0.3)",
                  textDecoration: "none",
                },
              }}
            >
              <FormattedMessage id="landing_recruiter.prices.download_button" />
            </Button>
          </Box>
        </Box>
      </Box>

      <Modal
        open={showModal}
        onClose={() => setShowModal(false)}
        aria-labelledby="pricing-modal-title"
        aria-describedby="pricing-modal-description"
      >
        <PricingModal closeModal={() => setShowModal(false)} />
      </Modal>
    </>
  );
};

export default BrochureSection;
